import React from 'react'
import { Box, FormControl, Typography, Grid } from '@material-ui/core'
import langs, { __ } from '../../langs'

type PropsAdvantages = {
  title: string
  light: boolean
  advantages: any[]
}

export const Advantages = ({ title, advantages, light }: PropsAdvantages) => {
  const theme = light ? 'light' : 'dark'

  return (
    <>
      <h2 id="advantages">{title}</h2>
      <ul className={`advantages ${theme}`}>
        {advantages.map((el, index) => (
          <li key={index}>
            <div
              className="svg"
              dangerouslySetInnerHTML={{ __html: el.svg }}
            ></div>
            <div>
              <h3>{el.title}</h3>
              <p dangerouslySetInnerHTML={{ __html: el.content }} />
            </div>
          </li>
        ))}
      </ul>
    </>
  )
}
